module.exports = __webpack_public_path__ + "img/item-webinars.7fcc5bbd.svg";